import { call, put, takeEvery } from 'redux-saga/effects'
import * as auditActions from '@redux/ducks/common/audit.Ducks'
import * as auditApi from '@apis/common/audit.Api'

interface FetchSaga {
  type: string
  payload: string
}

interface FetchAuditByEntitySaga {
  type: string
  payload: {
    entityType: string
    entityId: string
  }
}

function* fetchListAudit({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof auditApi.getListAuditLogs> = yield call(auditApi.getListAuditLogs, queryString)
    yield put(auditActions.getListAuditSuccess(res))
  } catch (error) {
    yield put(auditActions.getListAuditFail(error))
  }
}

function* fetchAuditStats({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof auditApi.getAuditLogsStats> = yield call(auditApi.getAuditLogsStats, queryString)
    yield put(auditActions.getAuditStatsSuccess(res))
  } catch (error) {
    yield put(auditActions.getAuditStatsFail(error))
  }
}

function* fetchAuditByEntity({ payload }: FetchAuditByEntitySaga) {
  try {
    const res: ReturnType<typeof auditApi.getAuditLogsByEntity> = yield call(
      auditApi.getAuditLogsByEntity,
      payload.entityType,
      payload.entityId
    )
    yield put(auditActions.getAuditByEntitySuccess(res))
  } catch (error) {
    yield put(auditActions.getAuditByEntityFail(error))
  }
}

export default function* watchAudit() {
  yield takeEvery(auditActions.getListAudit.toString(), fetchListAudit)
  yield takeEvery(auditActions.getAuditStats.toString(), fetchAuditStats)
  yield takeEvery(auditActions.getAuditByEntity.toString(), fetchAuditByEntity)
}
